<template>
    <div class="productItem">
        <div class="info">
            <div class="createdAt">{{ formatDate }}</div>
            <div class="author">作者 {{note.Lecturer?.name ?? note.author}}</div>
        </div>
        <div class="text">
            <a :href="link">
                <h3><div class="title" v-html="title">{</div></h3>
                <input type="hidden" class="type_id_specId_key" :data-type_id_specId_key="typeIdSpecIdKey"
                       name="type_id_specId_key[]" :value="typeIdSpecIdKey">
            </a>
            <div class="description" v-html="nl2brAndEscapeHtml"/>
            <a :href="link">
                <div class="moreBtn">閱讀更多</div>
            </a>
        </div>
        <div class="pic">
            <a :href="link">
                <img :src="picUrl" @error="handleImageError" />
            </a>
        </div>
    </div>
</template>

<script>
import FavoriteComponent from 'Vue/Web/Shop/Course/FavoriteComponent.vue';

export default {
    name: 'LongNoteComponent',
    components: {
        FavoriteComponent,
    },
    props: {
        note: {
            type: Object,
            default: () => {},
        },
        postAt: {
            type: String,
            default: '',
        },
        favoriteAdded: {
            type: Boolean,
            default: false,
        },
        noteId: {
            type: Number,
            default: 0,
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        slug: {
            type: String,
            default: '',
        },
        picUrl: {
            type: String,
            default: '',
        },
        pageType: {
            type: String,
            default: '',
        },
        pageName: {
            type: String,
            default: '',
        },
        pagePosition: {
            type: String,
            default: '',
        },
        typeIdSpecIdKey: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            favoriteAddedData: false,
            computedLoveIcon: 'img/pic/love.svg',
            computedStarIcon: 'img/pic/star.png',
            link: '',
        };
    },
    computed: {
        formatDate() {
            const options = { month: 'short', day: '2-digit', year: 'numeric' };
            return new Date(this.postAt).toLocaleDateString('en-US', options);
        },
        nl2brAndEscapeHtml() {
            if (this.description?.length > 0) {
                const string = this.description.replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#039;');
                return string.replace(/(?:\r\n|\r|\n)/g, '<br>');
            }

            return '';
        },
    },
    created() {
        this.favoriteAddedData = this.favoriteAdded;
        this.link = `article/${this.slug}`;
    },
    mounted() {
    },
    methods: {
        priceLowCheck() {
            return this.minPrice < this.originalPrice;
        },
        handledChangeFavorite(data) {
            this.favoriteAddedData = data;
        },
        handleImageError(event) {
            // eslint-disable-next-line no-param-reassign
            event.target.src = 'img/pic/no_image_icon.png';
        },
    },
};
</script>
<style lang="scss" scoped>
$maincolor : #72ca4a;
.productItem{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 4% 0%;
    margin: 0;
    @media (max-width: 1366.98px) {
        padding: 4% 3%;
    }
    @media (max-width: 1024.98px) {
        padding: 4%;
    }
    @media (max-width: 479.98px) {
        padding: 8% 4%;
    }
    &:hover {
        background-color: #eee;
    }
    .info {
        display: flex;
        width: 100%;
        margin-bottom: 1rem;
        .createdAt {
            min-width: 95px;
            color: $maincolor;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 1rem;
        }
        .author {
            color: #999;
            line-height: 20px;
            word-wrap: break-word;
            min-width: 10%;
        }
    }
    .text {
        display: flex;
        flex-direction: column;
        width: 55%;
        margin-right: 5%;
        @media (max-width: 479.98px) {
            width: 100%;
            margin-right: 0;
            margin-bottom: 2rem;
        }
        .title {
            color: #333;
            font-size: 20px;
            margin-bottom: 12px;
            @media (max-width: 1366.98px) {
                font-size: 18px;
                margin-bottom: 8px;
            }
            @media (max-width: 768.98px) {
                font-size: 16px;
            }
        }
        .description {
            color: #777;
            font-size: 14px;
            letter-spacing: 2px;
            margin-bottom: 1.5rem;
            @media (max-width: 768.98px) {
                font-size: 13px;
            }
        }
        .moreBtn {
            display: inline-block;
            color: white;
            background-color: $maincolor;
            text-align: center;
            font-size: 14px;
            border-radius: 6px;
            padding: 6px 35px;
            float: right;
            &:hover {
                background-color: darken($maincolor, 10%);
                transition: 0.3s;
            }
            @media (max-width: 768.98px) {
                display: none;
            }
        }
    }
    .pic {
        width: 40%;
        @media (max-width: 479.98px) {
            width: 100%;
        }
    }
}
</style>
